import {Navigate} from 'react-router-dom';
import {Loading} from '../../../components';
import {
    useName,
    useQuery,
} from '../../../hooks';
import {Routes} from '../../../Routes';
import {Endpoint} from '../../../util';
import {PhysicianReviewStatus} from '../../auth/guards';
import {PageContent} from './PageContent';

export function WhileAuthenticated() {
    const {
        error,
        loading,
        name,
    } = useName();
    const {
        data: {physicianReviewStatus} = {},
        isPending: isSummaryPending,
    } = useQuery({endpoint: Endpoint.SUMMARY});

    if (loading || isSummaryPending) {
        return (
            <div className={'center-within'}>
                <Loading />
            </div>
        );
    }

    // This index route sits outside ReorderTestGuard so logged-out users can land on it
    // Therefore we re-add the relevant ReorderTestGuard check here
    if (physicianReviewStatus === PhysicianReviewStatus.UNAVAILABLE) {
        return (
            <Navigate
                replace={true}
                to={Routes.TEST_ORDER_UNAVAILABLE}
            />
        );
    }

    return (
        <PageContent
            buttonDataTestId={'continue-button'}
            buttonKey={'testReorder.order.loggedIn.button.text'}
            buttonTitleKey={'testReorder.order.loggedIn.button.title'}
            name={error ? null : name}
            titleDataTestId={'test-reorder-while-authenticated'}
            titleKey={'testReorder.order.loggedIn.title'}
        />
    );
}
